export default {
  regex: {
    utf8: /^[a-zA-Z ,.'-]{3,}$/,

    percent: /^([0-9۰-۹٠-٩]{1,2}|100|0)$/,

    OTPCode: /^[0-9۰-۹٠-٩]{5}$/,

    name: '^[{langRegex}\\s\(\)\.,\/]+$',

    // user
    user: {
      name: '^([{langRegex}\\s\(\)\.,\/]+)$',
      lastName: '^([{langRegex}\\s\(\)\.,\/]+)$',
      email: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/
    },

    //message
    message: {
      key: /^([A-Z0-9]+)$/,
      template: /^([a-zA-Z0-9]+)$/
    },

    // store
    store: {
      name: '^([{langRegex}\\s\(\)\.,\/]+)$',
      code: /^[0-9]{1,}$/
    },

    // treasury
    treasury: {
      bank: {
        name: '^([{langRegex}\\s\(\)\.,\/]+)$',
        shabaNumber: /^(?=.{15,34}$)[A-Z]{2}\d{2}[A-Z0-9]{11,30}$/,
        accountNumber: /^\d{6,15}$/
      },

      paymentGateway: {
        name: '^([{langRegex}\\s\(\)\.,\/]+)$',
        transferId: /^[a-zA-Z0-9_\/-]{4,70}$/
      },

      receive: {
        transactionId: /^[A-Za-z0-9_-]{5,70}$/
      }
    },

    //event
    event: {
      subject: '^[{langRegex}\\s\(\)\.,\/]+$',
      content: '^[{langRegex}\\s\(\)\.,\/]+$'
    },

    // access group
    accessGroup: {
      name: '^[{langRegex}\\s\(\)\.,\/]+$'
    },

    customEmail: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,

    shaba: {
      prefix: 'AE',
      pattern: /^(?=.{15,34}$)[A-Z]{2}\d{2}[A-Z0-9]{11,30}$/
    },

    swiftCode: /^[A-Z]{4}[A-Z]{2}[A-Z0-9]{2}([A-Z0-9]{3})?$/,

    address: {
      name: '^[{langRegex}\\p{N}\\s\(\)\.,\/]+$',
      city: '^[{langRegex}\\s\(\)\.,\/]*$',
      address: '^[{langRegex}\\p{N}\\s\(\)\.,\/]+$',
      plaque: /^[0-9۰-۹٠-٩]{1,}$/,
      postalCode: /^[0-9۰-۹٠-٩]{10}$/
    }
  }
}
